import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Search, Ticket } from 'lucide-react';

export function BottomNav() {
  const { pathname } = useLocation();

  const tabs = [
    // [Sprint UI-6] "/" is the voucher feed, "/discounts" the front door
    // ("მთავარი", in the middle).
    { to: '/',          label: 'ფასდაკლებები', icon: Ticket, match: (p) => p === '/' },
    { to: '/discounts', label: 'მთავარი',      icon: Home,   match: (p) => p.startsWith('/discounts') || p.startsWith('/club') },
    { to: '/search',    label: 'ფასები',       icon: Search, match: (p) => p.startsWith('/search') },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-slate-100 pb-[env(safe-area-inset-bottom)]"
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-3 max-w-lg mx-auto">
        {tabs.map(({ to, label, icon: Icon, match }) => {
          const active = match(pathname);
          return (
            <Link
              key={to}
              to={to}
              className="flex flex-col items-center justify-center py-2.5 active:scale-95 transition-transform"
              data-testid={`bottom-nav-${to.replace('/', '') || 'home'}`}
            >
              <Icon
                className={`w-[22px] h-[22px] ${active ? 'text-blue-600' : 'text-slate-400'}`}
                strokeWidth={active ? 2 : 1.7}
              />
              <span className={`text-[11px] mt-1 font-medium ${active ? 'text-blue-600' : 'text-slate-500'}`}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNav;
